module.exports = __webpack_public_path__ + "img/ico_defualt_pattern_01.43c7abcf.png";